import { defineMessages } from 'react-intl';
import * as Actions from '../../../../store/csw/csw.actions';
import * as InventoryActions from '../../../../store/inventory/inventory.actions';

const messages = defineMessages({
  createLabel: {
    defaultMessage: 'Schedule Pickup',
    id: 'Q/RKXZ',
    description: 'CSW primary button label - Schedule Pickup',
  },
});

export const createLabel = {
  id: 'createLabel',
  translation: messages.createLabel,

  getActionFromFulfillmentPlanId: (fulfillmentPlanId) => {
    window.labelPrintStart = window.performance.now();
    return InventoryActions.allocateFulfillmentPlanFromOrderDetailsCsw(
      fulfillmentPlanId,
      Actions.createLabel(fulfillmentPlanId, false, true),
    );
  },
};
